
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";

interface Article {
  id: string;
  title: string;
}

interface ArticleListDeleteDialogProps {
  open: boolean;
  article: Article | null;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function ArticleListDeleteDialog({
  open,
  article,
  onCancel,
  onConfirm
}: ArticleListDeleteDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onCancel}>
      <DialogContent className="bg-black/20 border-white/10">
        <DialogHeader>
          <DialogTitle className="text-white">Confirm Deletion</DialogTitle>
          <DialogDescription className="text-gray-300">
            Are you sure you want to delete the article "{article?.title}"? This action cannot be undone.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel} className="border-white/20 hover:bg-white/5 text-white">
            Cancel
          </Button>
          <Button variant="destructive" onClick={onConfirm} className="border-white/20">
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
